import { useAuth } from "../../utils/authorization";
import { Layout } from "../global/Layout";
import { Navigate } from "react-router-dom";
import Avatar from '@mui/material/Avatar';
import CssBaseline from '@mui/material/CssBaseline';
import Box from '@mui/material/Box';
import LockOutlinedIcon from '@mui/icons-material/LockOutlined';
import Container from '@mui/material/Container';
import { SpinnerCircularFixed } from "../../assets/spinner/SpinnerCircularFixed";
import GoogleSignIn from "./GoogleSignIn";
import SignInWithCode from "./SignInWithCode";

export default function LoginContainer() {
    const { user, loading } = useAuth();
    const storeId = typeof user?.stores[0] === 'string' ? Number(user?.stores[0]) : user?.stores[0];

    if (loading) return (
        <div className="sync-widget-loading">
            <div className="spinner" style={{ height: '100vh' }}>
                <SpinnerCircularFixed />
            </div>
        </div>
    );

    if (user?.stores?.length === 1 && storeId !== 0) {
        return <Navigate to={`/management/${user.stores[0]}`} replace />;
    }

    if (user) {
        return <Navigate to="/stores" replace />;
    }

    return (
        <Layout>
            <div className="login">
                <Container component="main" maxWidth="xs">
                    <CssBaseline />
                    <Box className="login-container">
                        <Avatar className="avatar">
                            <LockOutlinedIcon />
                        </Avatar>
                        <h2>Sign in</h2>
                        <SignInWithCode />
                        <div className="separator">
                            <span>or</span>
                        </div>
                        <GoogleSignIn />
                    </Box>
                </Container>
            </div>
        </Layout>
    );
}